/**
 * Términos de Servicio, en español.
 *
 * Describen lo que la aplicación hace de verdad, incluido lo que NO hace.
 * Prometer de menos y cumplir es la única forma de que un documento así sirva
 * de algo el día que haga falta.
 */
export default {
    titulo: 'Términos de Servicio',
    actualizado: '10 de septiembre de 2026',

    intro: [
        'Al crear una cuenta en ShippingFULL aceptas estas condiciones. Léelas: son cortas y hay cosas que conviene saber antes, no después.',
        'ShippingFULL se opera desde Nueva Jersey, Estados Unidos.'
    ],

    secciones: [
        {
            titulo: '1. Qué es ShippingFULL',
            parrafos: [
                'Una herramienta para buscar productos en catálogos de proveedores, evaluarlos, publicarlos en tu tienda y llevar el seguimiento de tus pedidos.',
                '**Es una herramienta, no un vendedor ni un intermediario.** No compramos, no vendemos, no almacenamos mercancía, no enviamos paquetes y no gestionamos devoluciones. Todo eso ocurre entre tú, tu proveedor y tu comprador.'
            ]
        },
        {
            titulo: '2. Tu cuenta',
            parrafos: [
                'Debes tener 18 años o más y dar datos veraces. Eres responsable de tu contraseña y de lo que ocurra con tu cuenta.',
                'Si detectas un uso no autorizado, escríbenos a **support@shippingfull.com** y cambia tu contraseña: hacerlo invalida al momento todas las sesiones abiertas.'
            ]
        },
        {
            titulo: '3. Lo que tú eres responsable de cumplir',
            parrafos: [
                'Esta es la parte importante y la que más disgustos evita.',
                '**Las reglas de cada marketplace son tuyas, no nuestras.** eBay, por ejemplo, prohíbe revender en su plataforma lo comprado en otro marketplace. La aplicación intenta ayudarte: comprueba la pareja origen → destino y no te deja publicar lo que sabe que está prohibido. Pero esas reglas las escriben ellos, cambian sin avisarnos, y **la cuenta de vendedor que está en juego es la tuya**.',
                'También eres responsable de cumplir con los impuestos, las obligaciones de consumo y la protección de datos que te correspondan donde operes, incluyendo lo que debas a los compradores cuyos datos pasan por esta aplicación.'
            ]
        },
        {
            titulo: '4. Lo que la aplicación calcula, y con qué valor',
            parrafos: [
                'Las puntuaciones de producto, las estimaciones de ganancia, las sugerencias de precio y los análisis con inteligencia artificial son **orientativos**. Se calculan con los datos que los proveedores publican, que pueden estar incompletos o desactualizados.',
                'Cuando un dato no se ha podido comprobar, la aplicación lo dice en vez de rellenarlo: una nota incompleta se marca como incompleta y una estimación no se presenta como un juicio de inteligencia artificial. Aun así, **la decisión de comprar, publicar o fijar un precio es tuya**, y ninguna cifra de esta aplicación es asesoramiento financiero.'
            ]
        },
        {
            titulo: '5. Servicios de terceros',
            parrafos: [
                'Para funcionar, la aplicación se conecta a eBay, CJ Dropshipping, Amazon, AliExpress, Stripe, Google y Anthropic, entre otros.',
                'Tu relación con cada uno de ellos se rige por sus propias condiciones. Si uno cambia su interfaz, sube sus precios, limita su uso o cierra tu cuenta, **no depende de nosotros y no respondemos por ello**, aunque haremos lo razonable por adaptarnos.'
            ]
        },
        {
            titulo: '6. Suscripciones y pagos',
            parrafos: [
                'Hay un plan gratuito con límites de uso y un plan de pago sin ellos. Los pagos los procesa Stripe; nosotros no vemos ni guardamos los datos de tu tarjeta.',
                'Las suscripciones se renuevan automáticamente hasta que las canceles. Puedes cancelar cuando quieras desde la aplicación y conservarás el acceso hasta el final del periodo ya pagado.',
                'Si un cobro falla, te avisamos y el acceso al plan de pago puede suspenderse hasta que se regularice.'
            ]
        },
        {
            titulo: '7. Uso aceptable',
            parrafos: [
                'No puedes usar ShippingFULL para actividades ilegales, para infringir derechos de terceros, para publicar productos falsificados o prohibidos, ni para intentar acceder a datos de otras cuentas.',
                'Tampoco para consultar los proveedores a un ritmo que degrade su servicio: la aplicación respeta los límites que imponen y sortearlos por tu cuenta puede costarnos el acceso a todos.'
            ]
        },
        {
            titulo: '8. Disponibilidad, sin promesas que no podamos cumplir',
            parrafos: [
                'Hacemos lo razonable por mantener la aplicación en pie, pero **no garantizamos que esté disponible sin interrupciones ni libre de errores**.',
                'Depende de servicios que no controlamos, y cuando uno de ellos falla, algunas funciones dejan de estar disponibles. En esos casos la aplicación lo dice en pantalla en lugar de fingir un resultado.'
            ]
        },
        {
            titulo: '9. Límite de responsabilidad',
            parrafos: [
                'En la medida en que la ley lo permita, ShippingFULL no responde por lucro cesante, pérdida de datos, suspensión de tu cuenta en un marketplace, ni daños indirectos derivados del uso de la aplicación.',
                'Nuestra responsabilidad total, si la hubiera, no superará el importe que nos hayas pagado en los doce meses anteriores al hecho que la origine.'
            ]
        },
        {
            titulo: '10. Terminación',
            parrafos: [
                'Puedes dejar de usar la aplicación y cerrar tu cuenta cuando quieras.',
                'Podemos suspender una cuenta que incumpla estas condiciones o que ponga en riesgo el servicio para los demás. Si lo hacemos, te diremos por qué.'
            ]
        },
        {
            titulo: '11. Cambios en estas condiciones',
            parrafos: [
                'Si cambian, actualizaremos la fecha del encabezado y te avisaremos dentro de la aplicación cuando el cambio sea importante. Seguir usando ShippingFULL después implica aceptarlas.'
            ]
        },
        {
            titulo: '12. Ley aplicable',
            parrafos: [
                'Estas condiciones se rigen por las leyes del estado de **Nueva Jersey, Estados Unidos**, sin atender a sus normas de conflicto de leyes.'
            ]
        },
        {
            titulo: '13. Contacto',
            parrafos: [
                '**support@shippingfull.com**'
            ]
        }
    ]
};
